import React from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import PopulationData from '../content/population_data.json'
import HistoricalData from '../content/historical_data.json'

const SEO = props => {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
          description
          baseUrl
          keywords
        }
      }
    }
  `)

  const defaults = data.site.siteMetadata

  if (defaults.baseUrl === '' && typeof window !== 'undefined') {
    defaults.baseUrl = window.location.origin
  }

  if (defaults.baseUrl === '') {
    console.error('Please set a baseUrl in your site metadata!')
    return null
  }

  let total = Object.values(HistoricalData)[
    Object.values(HistoricalData).length - 1
  ]

  let title =
    'Vaccine Updates (Live) - ' +
    ((total * 100) / PopulationData['USTotal']).toFixed(1) +
    '% of Americans Vaccinated'

  if (props.useDescription) {
    return (
      <Helmet>
        <script>var ezoicId = 257656; </script>
        <script
          type="text/javascript"
          src="//go.ezoic.net/ezoic/ezoic.js"
        ></script>
        <title>{title}</title>
        <link rel="icon" href="https://covidvaxcount.live/favicon.ico" />
        <link rel="canonical" href={defaults.baseUrl} />
        <meta name="keywords" content={defaults.keywords} />
        <meta name="description" content={defaults.description} />

        <meta property="og:url" content={defaults.baseUrl} />
        <meta
          property="og:image"
          content="https://covidvaxcount.live/preview.png"
        />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={defaults.description} />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={defaults.description} />
      </Helmet>
    )
  }

  return (
    <Helmet>
      <script>var ezoicId = 257656; </script>
      <script
        type="text/javascript"
        src="//go.ezoic.net/ezoic/ezoic.js"
      ></script>
      <title>{title}</title>
      <link rel="icon" href="https://covidvaxcount.live/favicon.ico" />
      <link rel="canonical" href={defaults.baseUrl} />
    </Helmet>
  )
}

export default SEO
